// Renders the layer of physical Totem towers on the map.
import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import { towerTotemIcon } from './mapAssets';

const TowersLayer = ({ towers, onOpenDetail }) => {
  if (!towers?.length) return null;
  return towers.map((t) => (
    <Marker key={`tower-${t.id}`} position={[t.lat, t.lng]} icon={towerTotemIcon}>
      <Popup>
        <div style={{ minWidth: 200 }}>
          <strong>🗼 {t.code}</strong>
          <div style={{ fontSize: 11, color: '#aaa', marginTop: 2 }}>{t.municipality}, {t.province}</div>
          <div style={{ fontSize: 11, marginTop: 4, color: '#fff' }}>
            <b style={{ color: '#A3FF12' }}>{t.radio_type || 'Torre'}</b>
            {t.infra_type && <> · {t.infra_type}</>}<br/>
            Altura: <b>{t.height_m ?? '?'} m</b><br/>
            Elevación: <b>{t.elevation_m ?? '?'} msnm</b><br/>
            Estado: <b>{t.status || '?'}</b>
          </div>
          <button onClick={() => onOpenDetail({ code: t.code, lat: t.lat, lng: t.lng })}
            data-testid={`btn-detail-${t.code}`}
            style={{ marginTop: 8, width: '100%', background: '#A3FF12', color: '#000', padding: '6px 10px', borderRadius: 6, fontWeight: 800, fontSize: 11, border: 'none', cursor: 'pointer' }}>
            Ver ficha completa →
          </button>
        </div>
      </Popup>
    </Marker>
  ));
};

export default React.memo(TowersLayer);
